const environmentSettings = Object.freeze({
    production: {
        stripePk: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
        REACT_APP_ENDPOINT:process.env.REACT_APP_ENDPOINT
    },
    development: {
      stripePk: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
      REACT_APP_ENDPOINT:process.env.REACT_APP_ENDPOINT
    },
    staging: {
        stripePk: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
        REACT_APP_ENDPOINT:process.env.REACT_APP_ENDPOINT,
    }
  });
  
  export default Object.freeze({
    ...environmentSettings[process.env.REACT_APP_ENV],
  });